import { CheckIcon } from "../icons/CheckIcon"
import { TimeTrackIcon } from "../icons/TimeTrackIcon"

function StageSettingsIcon({
    stage,
    isVisible
}) {
    if (isVisible === false) {
        return null
    }

    return (
        <div className="me-2 h-100 d-flex align-items-center">
            {stage.enable_timestamp &&
                <TimeTrackIcon color="#727580" className="ms-2" height={12} width={10}/>
            }

            {stage.require_approval_from_client &&
                <CheckIcon color="#727580" className="ms-2" height={10} width={14}/>
            }
        </div>
    )

}

export { StageSettingsIcon }